("use client");

import { ChevronsUpDown } from "lucide-react";

import { useAuth } from "@/hooks/use-auth";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/styles/ui/sidebar";
import { getDisplayName, UserAvatar, UserInfoDropdown } from "../user";

export function NavUser() {
  const { isMobile } = useSidebar();
  const { user } = useAuth();

  if (!user) return null;

  const displayName = getDisplayName(user);

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <UserInfoDropdown side={isMobile ? "bottom" : "right"}>
          <SidebarMenuButton
            size="lg"
            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
          >
            <UserAvatar user={user} />
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-medium">{displayName}</span>
              <span className="truncate text-xs">{user.email}</span>
            </div>
            <ChevronsUpDown className="ml-auto size-4" />
          </SidebarMenuButton>
        </UserInfoDropdown>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
